import React, { useMemo } from "react";
import { ECLRichTextViewer, ECLUserInfo } from "../../../../../index";
/*
 * 1. Get previous comment
 * 2. Display previous comment and new comment side by side
 * 3. Get all comments that have identical id's then get the most recent one
 * 4. Descending index + 1 Ascending index - 1
 * */

export default function CommentUpdate({
   comment,
   historyList,
   sort,
   username,
   projectId,
}) {
   const date =
      new Date(comment.time).toDateString() +
      " " +
      new Date(comment.time).toLocaleTimeString();

   // Handle this for ascending and desc
   const currentIndex = historyList.findIndex(
      (item) => item.timestamp === comment.timestamp,
   );
   let prevIndex;
   if (sort === "desc") {
      prevIndex = currentIndex + 1;
   } else {
      prevIndex = currentIndex - 1;
   }
   let prevComment = historyList[prevIndex];

   const viewer = useMemo(
      () => (
         <ECLRichTextViewer
            textAsMarkdown={comment.text}
            project_id={projectId}
         />
      ),
      [comment.text],
   );

   const prevViewer = useMemo(
      () => (
         <ECLRichTextViewer
            textAsMarkdown={prevComment.text}
            project_id={projectId}
         />
      ),
      [prevComment.text],
   );

   return (
      <article className="comment-history-item comment-update">
         <div className="left">
            <ECLUserInfo user={comment.user} hideName={true}></ECLUserInfo>
         </div>
         <div className="right">
            <div className="top">
               <strong className="username">{username}</strong>
               {/* Dynamic Message Based On Comment Type */}
               <div className="comment-message">Changed a Comment</div>
               <i className="date">{date}</i>
            </div>
            <div className="bottom">
               <div className="comment-action">
                  {/* Use Padding instead of */}
                  <span>{prevViewer}</span> &#8594;
               </div>
               <strong className="text">{viewer}</strong>
            </div>
         </div>
      </article>
   );
}
